/**
 * Which number the next text leaves from: the Roof Board line or the rep's
 * own cell, for the one person whose phone syncs (ADR 0090). Out of
 * TextsPanel.tsx because that file is at the size lint allows; nothing here
 * changed in the move. The dropdown of our lines (ADR 0310) stays on the
 * card, beside the box it governs.
 */

import {
  TEXT_FROM_LABEL,
  TEXT_FROM_NOTE,
  formatPhone,
  type TextFrom,
} from "@roof-hawk/core";

import { t } from "../../i18n";

/**
 * Which number this one leaves from.
 *
 * Only ever drawn for the person whose phone syncs. Everybody else has one
 * channel and does not need to be told there is a choice they cannot make.
 */
export function FromPicker({
  value,
  onChange,
  number,
}: {
  value: TextFrom;
  onChange: (next: TextFrom) => void;
  number: string;
}) {
  return (
    <div className="frompicker">
      <div className="actions" role="radiogroup" aria-label={t("Send from")}>
        {(["roof-board", "cell"] as const).map((choice) => (
          <button
            key={choice}
            type="button"
            role="radio"
            aria-checked={value === choice}
            // `addrow ghost` is this app's unselected filter button and
            // `.active` is the chosen one. A plain `addrow` is solid blue —
            // the same as `btn-primary` — so the first version of this drew
            // both choices identically and there was no way to tell which
            // number a text was about to leave from.
            className={`addrow ghost${value === choice ? " active" : ""}`}
            onClick={() => onChange(choice)}
          >
            {t(TEXT_FROM_LABEL[choice])}
          </button>
        ))}
      </div>
      <p className="na-hint" style={{ marginTop: 6, maxWidth: 520 }}>
        {t(TEXT_FROM_NOTE[value])}
        {value === "cell"
          ? ` ${t("Messages will open to {number}.", { number: formatPhone(number) ?? "" })}`
          : ""}
      </p>
    </div>
  );
}
